<template>
  <b-card
    v-if="payment"
    class="card-transaction"
    no-body
  >
    <b-card-header>
      <b-card-title>{{ $t('Financial information') }}</b-card-title>
    </b-card-header>

    <b-card-body>
      <div
        class="d-flex justify-content-between mb-1"
      >
        <span>{{ $t('Amount') }}</span>
        <span class="font-weight-bold">{{ payment.amount | numberFormat }} {{ $t('Currency') }}</span>
      </div>
      <template v-for="(discount,key) in payment.discounts">
        <div
          v-if="discount.amount > 0"
          :key="key"
          class="d-flex justify-content-between mb-1 text-info"
        >
          <span>{{ discount.title }} <span v-if="discount.info.code > 0">({{ discount.info.code }})</span> <span v-if="discount.percent > 0">({{ discount.percent | numberFormat }}%)</span></span>
          <span class="font-weight-bold">{{ discount.amount | numberFormat }} {{ $t('Currency') }}</span>
        </div>
      </template>
      <div
        v-if="payment.discount > 0"
        class="d-flex justify-content-between mb-1 text-danger"
      >
        <span>{{ $t('Total discount') }}</span>
        <span class="font-weight-bold">{{ payment.discount | numberFormat }} {{ $t('Currency') }}</span>
      </div>
      <div class="d-flex justify-content-between mb-1 text-warning">
        <span>{{ $t('Tax amount') }} ({{ payment.tax_percent | numberFormat }}%)</span>
        <span class="font-weight-bold">{{ payment.tax_amount | numberFormat }} {{ $t('Currency') }}</span>
      </div>
      <div class="d-flex justify-content-between mb-1 text-success">
        <span>{{ $t('Payable amount') }}</span>
        <span class="font-weight-bold">{{ payment.total_amount | numberFormat }} {{ $t('Currency') }}</span>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
  },
  props: {
    payment: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
